<template>
  <li class="nav-item dropdown base-nav-item">
    <a
      :id="id"
      class="nav-link --dropdown-toggle"
      href="#"
      role="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <div class="base-nav-item__icon">
        <fa-icon :icon="icon" />
      </div>
      <div class="base-nav-item__title">
        {{ title }}
      </div>
    </a>
    <div
      class="dropdown-menu dropdown-menu-right"
      :aria-labelledby="id"
    >
      <slot />
    </div>
  </li>
</template>

<script>
export default {
    name: 'BaseNavDropdown',
    props: {
        id: {
            type: String,
            default: 'DropdownMenu',
        },
        title: {
            type: String,
            default: 'Title',
        },
        icon: {
            type: String,
            default: 'bug',
        },
        badge: {
            type: Number,
            default: null,
        },
    },
};
</script>

<style lang="scss">
.base-nav-item{
    position: relative;

    .nav-link{
        padding-top   : 0 !important;
        padding-bottom: 0 !important;
        padding-left  : 1rem !important;
        padding-right : 1rem !important;
    }
    & .router-link-active.nav-link{
        color: #6EB1FF !important;
    }
    &:hover{
        text-decoration: none;
    }
    &__icon{
        text-align: center;
        font-size: 1.3rem;
    }
    &__title{
        font-size: 0.625rem;
        text-transform: uppercase;
    }
    &__badge{
        background-color: #FB2453;
        position        : absolute;
        top             : 0;
        left            : calc(50% - 25px);
        width           : 18px;
        height          : 18px;
        color           : white;
        font-size       : 0.725rem;
        text-align      : center;
        border-radius   : 50px;

    }
}
</style>
